import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * Ce qu'il manque pour que le bouton accepte.
 *
 * Un bouton grisé ne se distingue pas d'un bouton cassé. Devant le formulaire
 * des courriels, dont la colonne n'avait pas été devinée parce qu'elle ne
 * s'appelait ni « email », ni « mail », ni « courriel », rien à l'écran ne
 * disait qu'il restait un choix à faire : l'opération avait l'air en panne.
 * Onze formulaires refusaient d'agir de la même façon silencieuse.
 *
 * Les raisons arrivent ici **déjà traduites**. Le composant ne connaît aucune
 * clé : il faudrait la composer à la volée, et le garde-fou qui traque les
 * traductions mortes ne voit que les clés écrites en toutes lettres.
 */
const MissingChoice = ({ reasons }) => {
  const missing = (reasons || []).filter(Boolean);
  if (missing.length === 0) return null;

  return (
    <div
      role="status"
      data-testid="missing-choice"
      className="flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900"
    >
      <AlertCircle className="h-4 w-4 flex-shrink-0 mt-0.5" />
      <span>{missing.join(' · ')}</span>
    </div>
  );
};

export default MissingChoice;
